import * as Yup from 'yup';
import {
  createReservation,
  setInProgressQuote,
} from 'store/reservations/actions';
import i18n from '@i18n';
import { VIEW_CREATE_RESERVATION } from 'utils/roles/permissions/reservationsPermissions';
import { validateRolePermissions } from 'utils/roles';
import { CREATE_INTERNAL_PRICE_QUOTE } from '../../../../../utils/roles/permissions/reservationsPermissions';

const customer = Yup.string().nullable();

const schema = Yup.object().shape({
  customer,
  originSelector: Yup.string().required(i18n('ERROR__COMMONS__REQUIRED_FIELD')),
  otherOrigin: Yup.string().when('originSelector', {
    is: '3b18c632-3ae7-4e80-9346-dc8e7899d7db',
    then: Yup.string()
      .required(i18n('ERROR__COMMONS__REQUIRED_FIELD'))
      .max(100, i18n('ERROR__COMMONS__MAX_LENGTH', [100])),
    otherwise: Yup.string().nullable(),
  }),
  comment: Yup.string()
    .nullable()
    .max(255, 'Las observaciones no puede exceder los 255 caracteres'),
});

const config = {
  schema,
  initialTouched: {
    units: false,
    originSelector: true,
    otherOrigin: true,
    comment: true,
  },
  initialValues: {
    units: 1,
    originSelector: '',
    otherOrigin: '',
    comment: '',
  },
  enableReinitialize: true,
  validateOnChange: true,
  validateOnBlur: true,
  formatter: (values) => values,
  transformer: (values) => values,
  onCloseAction: () => setInProgressQuote(false),
  showContinue: validateRolePermissions(CREATE_INTERNAL_PRICE_QUOTE),
  submitForm: (values) => createReservation(values),
  btnSubmitLabel: 'Reservar',
  dialogs: {
    confirmation: {
      title: 'CONFIRMACIÓN DE REGISTRO',
      message:
        'Una vez cargada la información del cliente tendrás que editarlo manualmente\n¿Estás seguro que quieres continuar?',
      actionLabel: 'Sí, continuar',
      cancelLabel: 'Cancelar',
    },
    response: {
      successTitle: '¡BIEN HECHO!',
      errorTitle: '¡UPS! ALGO PASÓ!',
      successMessage:
        'El cliente se agregó de forma exitosa al catálogo, si deseas realizar algún cambio tendrás que buscarlo y editarlo manualmente.',
      errorMessage:
        'Hubo un error mientras procesabamos la información, por favor intenta de nuevo.',
      successLabel: 'Ir a Clientes',
      errorLabel: 'Reintentar',
      cancelLabel: 'Cancelar',
      successPath: '/customers/',
    },
  },
};

export default config;
